module.exports = __webpack_public_path__ + "img/IMG_20200726_203249.b957342e.jpg";